import actionConsts from "../../constants/actions";

const surveySequences = (state = [], action = {}) => {
	switch (action.type) {
		case actionConsts.RECEIVE_INIT_DATA:
			return action.payload.survey_sequences
				? action.payload.survey_sequences
				: [];
		default:
			return state;
	}
};

export default surveySequences;



// WEBPACK FOOTER //
// /src/reducers/uiState/surveySequences.js